import { useTranslation } from 'react-i18next'
import { MonitorCog } from 'lucide-react'

import { AdUnitBrowser } from '@/components/AdUnitBrowser'
import { Card, CardContent, CardHeader, CardIcon, CardTitle } from '@/components/ui/card'
import type { AdUnit } from '@/services/adUnits/adUnitsApi'

export interface DiagnosticAdUnitPickerProps {
  value: AdUnit[]
  onChange: (value: AdUnit[]) => void
}

/** Picks the ad units a diagnostic run makes its request on. */
export function DiagnosticAdUnitPicker({ value, onChange }: DiagnosticAdUnitPickerProps) {
  const { t } = useTranslation()
  return (
    <Card tone="insight">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <CardIcon icon={MonitorCog} />
          {t('targeting.types.adUnit.plural')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <AdUnitBrowser value={value} onChange={onChange} />
      </CardContent>
    </Card>
  )
}
